



















import { Component, Prop } from 'vue-property-decorator';    
import { GuardileoVueComponent } from '@/lib';    

@Component({})
export default class extends GuardileoVueComponent {
           
    @Prop({ default: false }) private disabled!: boolean;
    @Prop({ default: false }) private hide!: boolean;
    @Prop() private value!: boolean;

    toggle() {
        this.$emit('input', !this.value);
    }

    on_element_keyup(e: KeyboardEvent) {
        if (e.code == 'Space' || e.code == 'Enter') {
            this.toggle();
            e.preventDefault();
            e.stopPropagation();
        } 
    }
}
